var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.resales-all'),"text":_vm.$t('resales.description'),"name":"resales","url":_vm.$listRoutes.resales,"table":_vm.resales,"filters":_vm.resalesFilters,"defaultFilters":_vm.defaultCreatedAtFilter,"requireFilters":true,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }